import { runSafe } from "../utils";

export default function hijackPerformanceTiming() {
    const navigationStart = Date.now();
    try {
        Object.defineProperty(performance.timing, 'navigationStart', {
            get() {
                return navigationStart;
            },
            configurable: true,
        });

        const origin = performance.getEntriesByType;
        // @ts-ignore
        performance.getEntriesByType = function(typename: string) {
            if (typename === 'navigation') {
                // just break it so we don't need to care
                return [];
            } else {
                return origin.call(this, typename);
            }
        }
    
    } catch(e){
        console.error(e);
    }
   
    return {
        free() {
            try {
                Object.defineProperty(performance.timing, 'navigationStart', {
                    configurable: true,
                });
            } catch(e){
                console.error(e);
            }
        }
    }
}

export function hijackRequestStart() {
    runSafe(() => {
        const v = Date.now();
        Object.defineProperty(performance.timing, 'requestStart', {
            'configurable': true,
            get() {
                return v;
            }
        })
    });
}

export function hijackResponseStart() {
    runSafe(() => {
        const v = Date.now();
        Object.defineProperty(performance.timing, 'responseStart', {
            'configurable': true,
            get() {
                return v;
            }
        })
    });
}
